module.exports = __webpack_public_path__ + "static/media/supermarket-pos.df34e896.jpg";